import styled from "styled-components";

export const ContainerPictures = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: auto;
  overflow: visible;
  margin: 25px 0;
  padding: 0 50px;

  a {
    color: #000;
  }
`;

export const BoxImage = styled.div`
  width: 100%;

  div {
    width: 100% !important;
  }

  .catimg {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    cursor: zoom-in;
  }
`;
